/*
 * @Author: bz2021 bz2021@mail.sdu.edu.cn
 * @Date: 2025-07-06 11:43:11
 * @LastEditors: bz2021 bz2021@mail.sdu.edu.cn
 * @LastEditTime: 2025-07-07 19:59:42
 * @FilePath: \a_span\frontend\management-app\src\layout\MainLayout.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect, useState } from "react";
import { Layout, Menu, Dropdown, message, Button } from "antd";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  HomeOutlined,
  UserOutlined,
  ShopOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { useAtom } from "jotai";
import { loggedInUserAtom } from "../store/userAtom";
import request from '../utils/request'; // 添加request导入

const { Header, Content } = Layout;

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentPath, setCurrentPath] = useState(location.pathname);
  const [loggedInUser, setLoggedInUser] = useAtom(loggedInUserAtom);
  const [messageApi, contextHolder] = message.useMessage();

  // 获取用户信息并处理认证
  useEffect(() => {
    setCurrentPath(location.pathname);
    // 不需要请求用户信息的路径
    const authPaths = ['/login', '/register', '/forget'];
    if (authPaths.includes(location.pathname)) {
      return;
    }

    const fetchUserInfo = async () => {
      console.log('fetchUserInfo --')
      try {
        const response = await request({
          url: '/user_info',
          method: 'get'
        });
        setLoggedInUser(response.data);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // 清除本地存储并重定向到登录页
          localStorage.removeItem('token');
          setLoggedInUser(null);
          messageApi.error('登录已过期，请重新登录');
          navigate('/login');
        } else {
          messageApi.error('获取用户信息失败');
          console.error('获取用户信息失败:', error);
        }
      }
    };

    // 如果有token但没有用户信息，则获取用户信息
    const token = localStorage.getItem('token');
    if (token && !loggedInUser) {
      fetchUserInfo();
    }
  }, [navigate, location.pathname, setLoggedInUser, loggedInUser, messageApi]);

  // 使用useMemo缓存计算结果，当loggedInUser更新时重新计算，保证结果实时性
  const isAdmin = React.useMemo(() => {
    return loggedInUser?.admin || loggedInUser?.super_admin;
  }, [loggedInUser]);

  const isSuperAdmin = React.useMemo(() => {
    return loggedInUser?.super_admin;
  }, [loggedInUser]);

  // 退出登录处理
  const handleLogout = () => {
    localStorage.removeItem('token');
    setLoggedInUser(null);
    navigate('/login', { replace: true });
  };

  // 用户下拉菜单
  const userMenu = (
    <Menu>
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        退出登录
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {contextHolder} {/* 添加消息提示容器 */}
      <Header
        style={{
          background: "#fff",
          padding: "0 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Menu
          mode="horizontal"
          selectedKeys={[currentPath]}
          style={{ lineHeight: "64px", borderBottom: 0, flex: 1}}
        >
          <Menu.Item key="/home" icon={<HomeOutlined />}>
            <Link to="/home">首页</Link>
          </Menu.Item>
          {isSuperAdmin && (
            <Menu.Item key="/users" icon={<UserOutlined />}>
              <Link to="/users">用户管理</Link>
            </Menu.Item>
          )}
          {isAdmin && (
            <Menu.Item key="/my_users" icon={<UserOutlined />}>
              <Link to="/my_users">我的用户</Link>
            </Menu.Item>
          )}
          {isAdmin && (
            <Menu.Item key="/store_management" icon={<ShopOutlined />}>
              <Link to="/store_management">店铺管理</Link>
            </Menu.Item>
          )}
        </Menu>

        {loggedInUser?.username ? (
          <Dropdown overlay={userMenu} placement="bottomRight">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                padding: "0 16px",
              }}
            >
              <UserOutlined style={{ marginRight: 4 }} />
              <span>{loggedInUser.username}</span>
            </div>
          </Dropdown>
        ) : (
          <div style={{ display: "flex", gap: 16 }}>
            <Button 
              onClick={() => navigate('/login')}
             style={{ color: "#fff", background: "#1890ff", padding: "6px 16px", borderRadius: 4, cursor: "pointer" }}>
              登录
            </Button>
            <Button onClick={() => navigate('/register')} style={{ color: "#1890ff", border: "1px solid #1890ff", padding: "6px 16px", borderRadius: 4, cursor: "pointer" }}>
              注册
            </Button>
          </div>
        )}
      </Header>
      <Content style={{ padding: "24px", display: "flex", flexDirection: "column", minHeight: "calc(100vh - 64px)" }}>
        <div
          style={{
            background: "#fff",
            padding: 24,
            minHeight: "calc(100vh - 64px)",
          }}
        >
          <Outlet />
        </div>
      </Content>
    </Layout>
  );
};

export default MainLayout;
